import { QueryObserverOptions, useQuery } from 'react-query';

import { useDlVaultContract } from 'clients/contracts/hooks';
import FunctionKey from 'constants/functionKey';

import getClaimableRewards, { GetClaimableRewardsInput, GetClaimableRewardsOutput } from '.';

type TrimmedGetClaimableRewardsInput = Omit<GetClaimableRewardsInput, 'dlVaultContract'>;

export type UseGetClaimableRewardsQueryKey = [
  FunctionKey.GET_CLAIMABLE_REWARDS,
  TrimmedGetClaimableRewardsInput,
];

type Options = QueryObserverOptions<
  GetClaimableRewardsOutput,
  Error,
  GetClaimableRewardsOutput,
  GetClaimableRewardsOutput,
  UseGetClaimableRewardsQueryKey
>;

const useGetClaimableRewards = (input: TrimmedGetClaimableRewardsInput, options?: Options) => {
  const dlVaultContract = useDlVaultContract();

  return useQuery(
    [FunctionKey.GET_CLAIMABLE_REWARDS, input],
    () => getClaimableRewards({ dlVaultContract, ...input }),
    options,
  );
};

export default useGetClaimableRewards;
